import React, { useEffect, useState } from 'react';
import CardHeadMenu from '../Card/CardHeadMenu/CardHeadMenu';
import { useDispatch, useSelector } from 'react-redux';
import configServ from '../../services/config';
import { Autocomplete, Box, Checkbox, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, Stack, TextField, Typography } from '@mui/material';
import { Close, RestartAlt, Save } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { hideLoader, showLoader } from '../../redux/reducers/LoaderTrigger';
import Calculation from '../../utility/Calculations';
import { memo } from 'react';
import CreditNoteItem from './CreditNoteItem';

// FUNCTION
const CreditNoteCard = ({ editData, setEditData, isChanged, setIsChanged }) => {
    //#region code
    const dispatch = useDispatch();
    const { company_id, user_id } = useSelector(state => state.GlobalVariables);
    const [isCreate, setIsCreate] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [subscriptionPlans, setSubscriptionPlans] = useState([]);
    const initialFormData = {
        customer_id: null,
        invoice_id: null,
        credit_note_date: Calculation.GetCurrentDate(),
        reason: "",
        include_gst: true,
        tax_type: null,
        status: true,
    }
    const [formData, setFormData] = useState(initialFormData);
    const [invoiceList, setInvoiceList] = useState([]);
    const [validationError, setValidationError] = useState({});
    const initialProduct = [
        { item_id: null, rate: 0, tax: 0, quantity: 1, unit: null, tax_amount: 0, total_amount: 0 },
    ]
    const [products, setProducts] = useState(initialProduct);
    const [itemData, setItemData] = useState([]);

    useEffect(() => {
        if (editData !== null) {
            setIsCreate(true);
            setFormData({
                id: editData.id,
                customer_id: editData.customer_id,
                invoice_id: editData.invoice_id,
                credit_note_date: editData.credit_note_date,
                reason: editData.reason,
                include_gst: editData.include_gst,
                tax_type: editData.tax_type,
                taxable_value: editData.taxable_value,
                tax_amount: editData.tax_amount,
                total_amount: editData.total_amount,
                status: editData.status,
            });
            const result = editData.products.map((product) => ({
                id: product.id,
                item_id: product.item_id,
                rate: product.rate,
                quantity: product.quantity,
                tax: parseFloat(product.tax || 0),
                taxable_value: parseFloat(product.taxable_value || 0),
                tax_amount: parseInt(product.tax_amount || 0),
                total_amount: parseInt(product.total_amount)
            }));
            setProducts(result);
            setIsEdit(true);
        }
    }, [editData]);

    const fetchCustomers = async () => {
        try {
            const dataTosend = {
                company_id
            }
            const res = await configServ.get_customer(dataTosend);
            if (res.length > 0) {
                setCustomers(res);
            }
            else {
                setCustomers([]);
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    const fetchItems = async () => {
        try {
            const dataToSend = {
                company_id
            }
            const res = await configServ.getItemList(dataToSend);
            if (res.status === 200) {
                if (res.data && res.data.length > 0) {
                    const result = res.data.filter((x) => x.status === 1).map((item => ({
                        item_id: item.id,
                        name: item.item_name,
                        unit: item.unit,
                        rate: parseFloat(item.rate_unit) || 0,
                        tax: parseFloat(item.tax_rate) || 0,
                        // discount: parseFloat(item.discount) || 0,
                    })));
                    setItemData(result);
                }
            }
            else {
                setItemData([]);
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    const fetchData = async () => {
        try {
            dispatch(showLoader());
            await fetchCustomers();
            await fetchItems();
        }
        catch (e) {
            console.log(e);
        }
        finally {
            dispatch(hideLoader());
        }
    }

    const fetchTaxType = async () => {
        try {
            const dataToSend = {
                customer_id: formData.customer_id,
                company_id,
            }
            const res = await configServ.getTaxType(dataToSend);
            if (res.status === 200) {
                setFormData((prev) => ({
                    ...prev,
                    tax_type: res.tax_type
                }));
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    const fetchInvoiceList = async () => {
        try {
            const dataToSend = {
                company_id,
                customer_id: formData.customer_id
            }
            const res = await configServ.getActiveCustomerInvoice(dataToSend);
            if (res.status === 200) {
                setInvoiceList(res.data);
            }
            else {
                setInvoiceList([]);
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    const fetchInvoiceItems = async () => {
        try {
            const dataToSend = {
                invoice_id: formData.invoice_id
            }
            const res = await configServ.getInvoiceItems(dataToSend);
            if (res.status === 200) {
                const result = res.data.map((product) => ({
                    id: product.id,
                    item_id: product.item_id,
                    rate: product.rate,
                    quantity: product.qty,
                    tax: parseFloat(product.tax_rate || 0),
                    taxable_value: parseInt(product.amount) - parseInt(product.tax_amount || 0),
                    tax_amount: parseInt(product.tax_amount || 0),
                    total_amount: parseInt(product.amount)
                }));
                setProducts(result);
            }
            else {
                setProducts(initialProduct)
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        if (formData.customer_id && formData.include_gst === true) {
            fetchTaxType();
        }
        else if (formData.include_gst === false) {
            setFormData((prev) => ({
                ...prev,
                tax_type: null,
            }));
        }

        if (formData.customer_id) {
            fetchInvoiceList();
        }
    }, [formData.customer_id, formData.include_gst]);

    useEffect(() => {
        if (isCreate && customers.length === 0 && itemData.length === 0 && subscriptionPlans.length === 0) {
            fetchData();
        }
    }, [isCreate]);

    useEffect(() => {
        if (formData.invoice_id) {
            fetchInvoiceItems();
        }
        else {
            setProducts(initialProduct);
        }
    }, [formData.invoice_id]);

    const handleChange = async (e) => {
        try {
            const { name, value, type, checked } = e.target;
            setFormData((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value
            }));

            if (validationError[name]) {
                setValidationError((prev) => ({
                    ...prev,
                    [name]: ""
                }));
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    const handlePopup = () => {
        try {
            if (isCreate === true) {
                handleReset();
            }
            setIsCreate(!isCreate);
        }
        catch (error) {
            console.log(error);
        }
    };

    const handleValidation = async () => {
        try {
            let errors = {};
            if (!formData.customer_id) {
                errors.customer_id = "required";
            }
            if (!formData.credit_note_date) {
                errors.credit_note_date = "required";
            }
            if (!formData.reason) {
                errors.reason = "required";
            }

            setValidationError(errors);
            return Object.values(errors).every(error => error === "");
        }
        catch (e) {
            console.log(e);
        }
    }

    const handleSubmit = async () => {
        try {
            dispatch(showLoader());
            const isValid = await handleValidation();
            if (!isValid) {
                return false;
            }
            const dataToSend = {
                company_id,
                user_id,
                ...formData,
                taxable_value: products.reduce((sum, product) => sum + (product.taxable_value || 0), 0),
                tax_amount: products.reduce((sum, product) => sum + (product.tax_amount || 0), 0),
                total_amount: products.reduce((sum, product) => sum + (product.total_amount || 0), 0),
                products
            }
            if (isEdit) {
                const res = await configServ.updateCreditNote(dataToSend);
                if (res.status === 200) {
                    Swal.fire({
                        'icon': 'success',
                        'title': 'Success',
                        'text': res.message
                    });
                    setIsChanged(!isChanged);
                    handleClose();
                }
                else {
                    Swal.fire({
                        'icon': 'error',
                        'title': 'Error',
                        'text': 'Failed to update credit note.'
                    });
                }
            }
            else {
                const res = await configServ.createCreditNote(dataToSend);
                if (res.status === 200) {
                    Swal.fire({
                        'icon': 'success',
                        'title': 'Success',
                        'text': res.message
                    });
                    setIsChanged(!isChanged);
                    handleClose();
                }
                else {
                    Swal.fire({
                        'icon': 'error',
                        'title': 'Error',
                        'text': 'Failed to create credit note.'
                    });
                }
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            dispatch(hideLoader());
        }
    }

    const handleReset = () => {
        setFormData(initialFormData);
        setInvoiceList([]);
        setProducts(initialProduct)
        setValidationError({});
        setIsEdit(false);
        setEditData(null);
    }

    const handleClose = () => {
        setIsCreate(false);
        handleReset();
    }

    //#endregion

    return (
        <>
            <CardHeadMenu
                prefix={"Inv"}
                suffix={"Order"}
                title={"Credit Note"}
                handlePopup={handlePopup}
                isEdit={isEdit}
                create={isCreate}
            />
            {
                isCreate &&
                <><Grid container alignItems={'center'} spacing={1} sx={{
                    width: "100%",
                    backgroundColor: "#e3f3fc",
                    p: 2,
                    borderRadius: "10px",
                    border: "none",
                    margin: "10px",
                }}>
                    <Box width={'100%'} display={'flex'} alignItems={'flex-end'} justifyContent={'space-between'}>
                        <Grid container item xs={6} ml={1} alignItems={'flex-end'} justifyContent={'flex-start'}>
                            <Typography variant='body1' fontWeight={600}> Credit Note detail</Typography>
                        </Grid>
                        <Grid container item xs={6} alignItems={'flex-end'} justifyContent={'flex-end'}>
                            {isEdit ?
                                <IconButton title='close' sx={{ px: 1, py: 0, backgroundColor: "white", borderRadius: 3 }} onClick={handleClose}>
                                    <Close color='error' />
                                </IconButton>
                                :
                                <IconButton title='reset' sx={{ px: 1, py: 0, backgroundColor: "white", borderRadius: 3 }} onClick={handleReset}>
                                    <RestartAlt color='secondary' />
                                </IconButton>}
                            <IconButton title={isEdit ? 'update' : 'save'} sx={{ px: 1, py: 0, backgroundColor: "white", borderRadius: 3 }} onClick={handleSubmit}>
                                <Save color={isEdit ? 'success' : 'primary'} />
                            </IconButton>
                        </Grid>
                    </Box>
                    <Grid item xs={12} md={4}>
                        <Autocomplete
                            fullWidth
                            size="small"
                            name="customer_id"
                            options={customers}
                            getOptionLabel={(option) => option.fname} // Display customer name in the dropdown
                            isOptionEqualToValue={(option, value) => option.id === value?.id} // Avoid warning about value mismatch
                            value={customers.find((customer) => customer.id === formData.customer_id) || null} // Ensure value is controlled
                            onChange={(event, value) => {
                                const customEvent = {
                                    target: {
                                        name: "customer_id",
                                        value: value ? value.id : "",
                                    },
                                };
                                handleChange(customEvent); // Call the existing handleChange function with a custom event
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    name="customer_id"
                                    label="Customer"
                                    value={customers.find((customer) => customer.id === formData.customer_id) || null} // Ensure value is controlled
                                    sx={{ backgroundColor: "white" }}
                                    error={!!validationError.customer_id} />
                            )} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl size='small' fullWidth>
                            <InputLabel id="plan-input">Invoice</InputLabel>
                            <Select
                                disabled={!(!!(products[0].item_id === null))}
                                size='small'
                                fullWidth
                                labelId="plan-label"
                                id="plan-select"
                                name='invoice_id'
                                value={formData.invoice_id || ""}
                                label="Invoice"
                                onChange={handleChange}
                                sx={{ backgroundColor: 'white' }}
                            >
                                {invoiceList.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.invoice_number}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            type="date"
                            label="Credit Note Date"
                            variant="outlined"
                            fullWidth
                            size="small"
                            name="credit_note_date"
                            value={formData.credit_note_date}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            sx={{ backgroundColor: "white" }}
                            error={!!validationError.credit_note_date} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            size='small'
                            multiline
                            rows={2}
                            label='Reason'
                            name='reason'
                            value={formData.reason || ""}
                            onChange={handleChange}
                            sx={{ background: 'white' }}
                            error={!!validationError.reason} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Stack direction={"row"}>
                            <Box
                                sx={{
                                    borderRadius: "5px",
                                    backgroundColor: "white",
                                    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.3)",
                                }}
                            >
                                <FormControl component="fieldset">
                                    <FormLabel
                                        component="legend"
                                        sx={{ fontWeight: "bolder", marginLeft: "20px" }}
                                    >
                                        Tax in
                                    </FormLabel>
                                    <RadioGroup
                                        name="use-radio-group"
                                        row
                                        sx={{ marginLeft: "20px" }}
                                    >
                                        <FormControlLabel
                                            disabled={!formData.include_gst}
                                            checked={formData.tax_type === "CGST+SGST"}
                                            value="CGST_SGST"
                                            label="CGST + SGST"
                                            control={<Radio
                                                size="small"
                                                onClick={() => setFormData((prev) => ({
                                                    ...prev,
                                                    tax_type: "CGST+SGST",
                                                }))} />} />
                                        <FormControlLabel
                                            disabled={!formData.include_gst}
                                            checked={formData.tax_type === "IGST"}
                                            value="IGST"
                                            label="IGST"
                                            control={<Radio
                                                size="small"
                                                onClick={() => setFormData((prev) => ({
                                                    ...prev,
                                                    tax_type: "IGST",
                                                }))} />} />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        </Stack>
                    </Grid>

                    <CreditNoteItem products={products} setProducts={setProducts} itemData={itemData} include_gst={formData.include_gst} />

                    <Box width={'100%'} display={'flex'} alignItems={'flex-end'} justifyContent={'space-between'}>
                        <Grid container item xs={6} md={3} alignItems={'center'} justifyContent={'flex-start'}>
                            <FormControlLabel
                                control={<Checkbox />}
                                name="status"
                                checked={Boolean(formData.status)}
                                onChange={handleChange}
                                label="Status"
                                sx={{ fontWeight: "bold" }} />
                        </Grid>
                        <Grid container item xs={6} md={3} alignItems={'center'} justifyContent={'flex-start'}>
                            {/* <FormControlLabel
                                disabled={!(!!formData.customer_id) || !!(products[0].item_id !== null)}
                                control={<Checkbox />}
                                label="Include GST"
                                name="include_gst"
                                checked={!!formData.include_gst}
                                onChange={handleChange}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        // Toggle the Checkbox value on Enter key press
                                        handleChange({
                                            target: {
                                                name: "include_gst",
                                                value: "on",
                                                type: "checkbox",
                                                checked: !formData.include_gst,
                                            },
                                        });
                                    }
                                }} /> */}
                        </Grid>
                        <Grid container item xs={12} md={6} alignItems={'center'} justifyContent={'flex-end'} spacing={2}>
                            {isEdit ?
                                <IconButton sx={{ fontSize: '36px', backgroundColor: "white", borderRadius: 3, p: 0 }} title='close' onClick={handleClose}>
                                    <Close color='error' fontSize='36px' />
                                </IconButton>
                                :
                                <IconButton sx={{ fontSize: '36px', backgroundColor: "white", borderRadius: 3, p: 0 }} title='reset' onClick={handleReset}>
                                    <RestartAlt color='secondary' fontSize='36px' />
                                </IconButton>}
                            <IconButton sx={{ fontSize: '36px', backgroundColor: "white", borderRadius: 3, p: 0, mx: 1 }} title={isEdit ? 'update' : 'save'} onClick={handleSubmit}>
                                <Save color={isEdit ? 'success' : 'primary'} fontSize='36px' />
                            </IconButton>
                        </Grid>
                    </Box>
                </Grid>
                </>
            }
        </>
    )
}

export default memo(CreditNoteCard);
